/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The Doc model module.
 * @module model/Doc
 * @version 1.0.0
 */
class Doc {
    /**
     * Constructs a new <code>Doc</code>.
     * Doc definition
     * @alias module:model/Doc
     * @param type {String} 
     * @param needCertify {Boolean} 
     */
    constructor(type, needCertify) { 
        
        Doc.initialize(this, type, needCertify);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, type, needCertify) { 
        obj['type'] = type;
        obj['need_certify'] = needCertify;
    }

    /**
     * Constructs a <code>Doc</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Doc} obj Optional instance to populate.
     * @return {module:model/Doc} The populated <code>Doc</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Doc();

            if (data.hasOwnProperty('type')) {
                obj['type'] = ApiClient.convertToType(data['type'], 'String');
            }
            if (data.hasOwnProperty('need_certify')) {
                obj['need_certify'] = ApiClient.convertToType(data['need_certify'], 'Boolean');
            }
        }
        return obj;
    }


}

/**
 * @member {String} type
 */
Doc.prototype['type'] = undefined;

/**
 * @member {Boolean} need_certify
 */
Doc.prototype['need_certify'] = undefined;






export default Doc;

